import { API } from 'aws-amplify';

const client = {
  query: ({ query, variables }) => API.graphql({ query, variables }),
  mutate: ({ mutation, variables }) => API.graphql({ query: mutation, variables }),
};

export default client;
